<template>
  <div style="padding: 10px; min-height: 100px" v-loading="loading">
    <div v-if="detailData && detailData.settingInfo">
      <div class="customer-setting-form">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          v-if="detailData"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="">
            <config-input
              ref="configForm"
              :config="editModel.settingInfo && editModel.settingInfo.fields"
              v-model="editModel.settingValue"
            />
          </el-form-item>
          <el-form-item>
            <div style="margin-top: 20px">
              <el-button
                type="primary"
                :loading="editSubmit"
                :disabled="editSubmit"
                @submit.native.prevent
                @click="submitClick"
              >
                保存
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchDetailData" size="small">
        重新加载
      </el-button>
    </el-empty>
  </div>
</template>

<style lang="less" scoped>
.customer-setting-title {
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: #919191;
  border-radius: 5px;
  background: #f1f1f1;
}

.customer-setting-form {
  margin-bottom: 30px;
}
</style>

<script>
import configInput from '../../../../components/configInput.vue';

const defaultModel = {
  settingValue: ""
}

export default {
  components: {
    configInput
  },
  props: {
    settingKey: {
      type: String
    },
  },
  watch: {
    settingKey() {
      this.fetchDetailData();
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      detailData: null,
      editSubmit: false,
      editModel: null,
      editRules: {},
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          let submit = () => {
            this.editSubmit = true;
            this.requestApi("biz.customer.base.setting.edit", this.editModel, {
              showError: true
            }).then((resp) => {
              this.success("保存成功");
              this.fetchDetailData();
            }).finally(() => {
              this.editSubmit = false;
            });
          }
          if (this.$refs.configForm) {
            this.$refs.configForm.validate((valid, data) => {
              if (valid) {
                submit();
              } else {
                this.showValidate(data);
              }
            });
          } else {
            submit();
          }
        } else {
          this.showValidate(data);
        }
      });
    },
    fetchDetailData() {
      this.errorMsg = null;
      this.loading = true;
      return this.requestApi("biz.customer.base.setting.detail", {
        settingKey: this.settingKey
      }).then((resp) => {
        this.detailData = resp.data;
        this.editModel = Object.assign({}, defaultModel, {
          settingKey: this.settingKey,
          settingInfo: this.detailData.settingInfo,
          settingValue: this.detailData.settingValue
        })
      }).catch((err) => {
        this.errorMsg = (err && (err.msg || err.message))
          || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.fetchDetailData();
  },
};
</script>